import type { AppRouter } from "@papier/api";
import { env } from "@papier/env/env-frontend";
import { createTRPCClient, httpBatchStreamLink } from "@trpc/client";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import superjson from "superjson";
import { queryClient } from "./query";
import { generateRequestId } from "./request-id";

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchStreamLink({
      url: `${env.VITE_SERVERSIDE_HOST}/api/trpc`,
      transformer: superjson,
      fetch(url, options) {
        return fetch(url, {
          ...(options as RequestInit),
          // Ensure credentials are included for authentication
          credentials: "include",
        });
      },
      headers() {
        return {
          "x-request-id": generateRequestId(),
        };
      },
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  queryClient,
  client: trpcClient,
});
